<template>
  <div class=" is-fullwidth">
    
    <div >
     
      <h4 class="title is-size-4">Overview</h4>
      <div class="columns">
        <div class="column" >
          <div class="card" :class="{'has-background-success-light' : this.area == 'orders_rec'}" @click="area='orders_rec'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag is-primary mb-2" >Orders Rec</div>
              <br >
              {{ orders_rec_orders }} orders<br />
             {{ orders_rec_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
            <div class="card" :class="{'has-background-success-light' : this.area == 'in_artwork'}" @click="area='in_artwork'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag is-link mb-2" >In Artwork</div>
              <br >
              {{ in_artwork_orders }} orders<br />
             {{ in_artwork_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
          <div class="card" :class="{'has-background-success-light' : this.area == 'in_print'}" @click="area='in_print'" style="cursor:pointer"> 
            <div class="card-content">
              <div class="tag is-info mb-2" >In Print</div>
              <br >
              {{ in_print_orders }} orders<br />
             {{ in_print_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
          <div class="card" :class="{'has-background-success-light' : this.area == 'in_cutting'}" @click="area='in_cutting'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag is-success mb-2" >In Cutting</div>
              <br >
              {{ in_cutting_orders }} orders<br />
             {{ in_cutting_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
          <div class="card" :class="{'has-background-success-light' : this.area == 'wip_dublin'}" @click="area='wip_dublin'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag is-warning mb-2" >WIP Dublin</div>
              <br >
              {{ wip_dublin_orders }} orders<br />
             {{ wip_dublin_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
          <div class="card" :class="{'has-background-success-light' : this.area == 'wip_strabane'}" @click="area='wip_strabane'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag is-danger mb-2" >WIP Strabane</div>
              <br >
              {{ wip_strabane_orders }} orders<br />
             {{ wip_strabane_garments }} garments<br />
            </div>
          </div>
        </div>

        <div class="column" >
            <div class="card" :class="{'has-background-success-light' : this.area == 'wip_derry'}" @click="area='wip_derry'" style="cursor:pointer">
            <div class="card-content">
              <div class="tag  mb-2" >WIP Derry</div>
              <br >
             {{ wip_derry_orders }} orders<br />
             {{ wip_derry_garments }} garments<br />
            </div>
          </div>
        </div>

       
      </div>

      <hr />
      
    </div>

    
    <ProductionOrderList :area="'orders_rec'" :search="search" v-show="area=='orders_rec'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'in_artwork'" :search="search" v-show="area=='in_artwork'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'in_print'" :search="search" v-show="area=='in_print'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'in_cutting'" :search="search" v-show="area=='in_cutting'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'wip_strabane'" :search="search" v-show="area=='wip_strabane'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'wip_dublin'" :search="search" v-show="area=='wip_dublin'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>
    <ProductionOrderList :area="'wip_derry'" :search="search" v-show="area=='wip_derry'" @update_totals="updateTotals" :show_dublin_makeup_only="show_dublin_makeup_only" @update_dublin_makeup="updateDublinMakeup"/>

        
    
    <br />
    <button class="button is-success is-small" @click="exportXLS()" >Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import ProductionOrderList from './ProductionOrderList.vue'

import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
    ProductionOrderList
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate DESC',
      location: '',
      search: '',
      end_date: '',
      start_date: '',
      exclude_socks: 0,
      include_blanks: 1,
      accessToken: '',
      makeup_location_id: '', // Always blank on this page
      area : 'orders_rec',
      orders_rec_orders: '',
      orders_rec_garments: '',
      in_artwork_orders: '',
      in_artwork_garments: '',
      in_print_orders: '',
      in_print_garments: '',
      in_cutting_orders: '',
      in_cutting_garments: '',
      wip_derry_orders: '',
      wip_derry_garments: '',
      wip_dublin_orders: '',
      wip_dublin_garments: '',
      wip_strabane_orders: '',
      wip_strabane_garments: '',
      show_dublin_makeup_only: false
    }
  },
   methods: {
    exportXLS() {
      var wb = XLSX.utils.book_new();
      
      wb.SheetNames.push("Orders Rec");
      var ws1 = XLSX.utils.table_to_sheet(document.getElementById('orders_rec_export'));
      wb.Sheets["Orders Rec"] = ws1;

      wb.SheetNames.push("Artwork");
      var ws2 = XLSX.utils.table_to_sheet(document.getElementById('in_artwork_export'));
      wb.Sheets["Artwork"] = ws2;

      wb.SheetNames.push("Printing");
      var ws3 = XLSX.utils.table_to_sheet(document.getElementById('in_print_export'));
      wb.Sheets["Printing"] = ws3;

      wb.SheetNames.push("Cutting");
      var ws4 = XLSX.utils.table_to_sheet(document.getElementById('in_cutting_export'));
      wb.Sheets["Cutting"] = ws4;
      
      wb.SheetNames.push("WIP Dublin");
      var ws5 = XLSX.utils.table_to_sheet(document.getElementById('wip_dublin_export'));
      wb.Sheets["WIP Dublin"] = ws5;

      wb.SheetNames.push("WIP Strabane");
      var ws6 = XLSX.utils.table_to_sheet(document.getElementById('wip_strabane_export'));
      wb.Sheets["WIP Strabane"] = ws6;

      wb.SheetNames.push("WIP Derry");
      var ws7 = XLSX.utils.table_to_sheet(document.getElementById('wip_derry_export'));
      wb.Sheets["WIP Derry"] = ws7;
      

      XLSX.writeFile(wb, 'Open Orders Pat.xlsx')

    },
    updateTotals(this_area, orders_total, garments_total) {
        this[this_area + '_orders']  = orders_total
        this[this_area + '_garments']  = garments_total
        console.log(this_area)
    },
    updateDublinMakeup(newValue) {
        this.show_dublin_makeup_only = newValue
    },
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getOpenOrders(this.accessToken, this.order_by, this.start_date, this.end_date,  this.exclude_socks, this.makeup_location_id, this.include_blanks, this.location)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      getStartDate() {
            
            var d = new Date("2023-01-01");
            
            //d.setDate(d.getDate() - 90);
            return d.toISOString().slice(0,10);
             
      },
      getEndDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() + 7);
            return d.toISOString().slice(0,10);
             
    },
    updateExcludeSocks() {
      if(this.exclude_socks == 1 || this.exclude_socks == "1")
      {
        this.exclude_socks = 0
      }
      else{
        this.exclude_socks = 1
      }
    },
    updateIncludeBlanks() {
      if(this.include_blanks == 1 || this.include_blanks == "1")
      {
        this.include_blanks = 0
      }
      else{
        this.include_blanks = 1
      }
    }
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
           // {
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.range_name.toLowerCase().includes(this.search.toLowerCase()) || row.designname.toLowerCase().includes(this.search.toLowerCase()) || row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }
          

          return filteredOrders
       
     },
     garment_total_qty: function() {
      let total = this.filteredOrders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     orderStatusCounts() {
      // Initialize counts for each status
      const counts = {
        'With Artwork': { orders: 0, quantity: 0 },
        'Artwork Completed': { orders: 0, quantity: 0 },
        'Printing Complete': { orders: 0, quantity: 0 },
        'Cutting Complete': { orders: 0, quantity: 0 },
        'In Makeup': { orders: 0, quantity: 0 },
        'Unknown': { orders: 0, quantity: 0 },
      };

      // Loop through orders and update counts based on status
      this.filteredOrders.forEach(order => {
        const current_status = order.current_status;
        counts[current_status].orders++;
        counts[current_status].quantity += order.total_qty;
      });

      return counts;
    },
  },

  // Fetches posts when the component is created.
  mounted() {
    this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getMakeupLocations();
        });
  },
 
  created() {

    //if (localStorage.open_orders_makeup_location_id) {
    //  this.makeup_location_id = localStorage.open_orders_makeup_location_id;
    //}
    //else{
    //  this.makeup_location_id = ''
    //}

    if (localStorage.open_orders_location) {
      this.location = localStorage.open_orders_location;
    }
    else{
      this.location = ''
    }

    if (localStorage.open_orders_search) {
      this.search = localStorage.open_orders_search;
    }
    else{
      this.search = ''
    }

    if (localStorage.open_orders_start_date) {
      this.start_date = localStorage.open_orders_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.open_orders_end_date) {
      this.end_date = localStorage.open_orders_end_date;
    }
    else{
      this.end_date = this.getEndDate()
    }

    if (localStorage.open_orders_exclude_socks) {
      this.exclude_socks = localStorage.open_orders_exclude_socks;
    }
    else{
      this.exclude_socks = 0
    }

    if (localStorage.open_orders_include_blanks) {
      this.include_blanks = localStorage.open_orders_include_blanks;
    }
    else{
      this.include_blanks = 0
    }
      
  },
  watch: {
    /*makeup_location_id: function () {
      localStorage.open_orders_makeup_location_id = this.makeup_location_id

      if(this.makeup_location_id == '')
      {
        this.include_blanks = 1
      }

      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },*/
    location: function () {
      localStorage.open_orders_location = this.location

      //if(this.location == '')
      //{
      //  this.include_blanks = 1
      //}

      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    search: function () {
      localStorage.open_orders_search = this.search
      
    },
    start_date: function () {
      localStorage.open_orders_start_date = this.start_date
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    end_date: function () {
      localStorage.open_orders_end_date = this.end_date
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    exclude_socks: function () {
      localStorage.open_orders_exclude_socks = this.exclude_socks
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
    include_blanks: function () {
      localStorage.open_orders_include_blanks = this.include_blanks
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

